<template>
  <el-container class="pages-common pre-tax-index">
    <leftNav />
    <el-main class="main-body">
      <div class="page-header">
        <div class="title">参数管理</div>
        <div>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="dialogVisible = true"
          >
            新 增
          </el-button>
        </div>
      </div>
      <div class="page-main">
        <el-table :data="tableData" border stripe size="small" max-height="500">
          <el-table-column
            prop="item"
            label="扣款项目"
            width="220"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                :disabled="!scope.row.canDelete"
                @click="delectParameter(scope.row.id)"
                type="danger"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog
        title="新增扣款项目"
        :visible.sync="dialogVisible"
        width="30%"
        top="13vh"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <div class="demo-input-suffix">
          <label style="width: 110px">扣款项目名称：</label>
          <el-input
            style="width: calc(100% - 110px)"
            placeholder="请输入扣款项目名称"
            v-model="project"
            onkeyup="value=value.replace(/\s+/g,'')"
          ></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="AddParams">确 定</el-button>
        </span>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import leftNav from "../components/nav.vue";
import { delParams, getchargeItem, addParams } from "../api/index";
export default {
  components: {
    leftNav,
  },
  data() {
    return {
      dialogVisible: false,
      project: "",
      tableData: [],
    };
  },
  mounted() {
    document.title = "参数管理";
    this.queryList();
  },
  methods: {
    queryList() {
      let data = {};
      getchargeItem({
        current: 1,
        size: 1000,
      }).then((res) => {
        console.log(res);
        this.tableData = res.data.rows;
      });
    },
    delectParameter(id) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delParams(id)
            .then((res) => {
              if (res.code == 200) {
                this.showMessage("success", "删除成功");
                this.queryList();
              } else {
                this.showMessage("error", res.message);
              }
            })
            .catch((res) => {
              console.log(res);
            });
        })
        .catch(() => {
          this.showMessage("info", "取消删除");
        });
    },
    AddParams() {
      if (this.project == "" ||this.project == " ") {
        this.showMessage("error", "项目名称不能为空！");
        return false;
      }
      addParams({ item: this.project })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.showMessage("success", "添加成功");
            this.queryList();
          } else {
            this.showMessage("error", res.message);
          }
        })
        .catch((res) => {
          console.log(res);
        });
      this.dialogVisible = false;
      this.project = "";
    },
    showMessage(type, msg) {
      this.$message({
        message: msg,
        type: type,
        duration: 5000,
        center: true,
      });
    },
  },
};
</script>

<style>
</style>
